// extracted by mini-css-extract-plugin
export var cartContainer = "_nu-4";
export var gray = "_nu-1";
export var itemContainer = "_nu-2";
export var itemDetails = "_nu-3";
export var strong = "_nu-0";